import React from 'react';

import Header from './header';
import Menu from './menu';

class mainLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  };
     
      
    }
    render() { 

        return ( 
            <div className="mainApp" id="wrapper">
              
                <nav className="navbar navbar-default navbar-fixed-top" role="navigation">
                    <Header />
                    <Menu />
                </nav>
                {this.props.children}
            </div>
        );
    }
}
 
export default mainLayout;
